import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-link-out',
  imports: [CommonModule, IconComponent],
  templateUrl: './link-out.component.html',
  styleUrl: './link-out.component.scss',
})
export class LinkOutComponent {
  /**
   * The label text displayed on the link
   */
  label = input.required<string>();

  /**
   * The URL for the link
   */
  href = input.required<string>();

  /**
   * Target attribute for the link
   */
  target = input<'_blank' | '_self' | '_parent' | '_top'>('_blank');

  /**
   * Whether the link is disabled
   */
  disabled = input<boolean>(false);
}
